import { isMobileBrowser } from "./checkDeviceType"

export const adjustToggle = () => {
    if(isMobileBrowser()){
        const toggle = document.getElementById("theme-toggle");
        if (toggle) {
          toggle.style.left = "10px";
        }
    }
}